import { FormControl, MenuItem, Select, SelectChangeEvent, useTheme } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


export default function PeriodDropdown({
    value,
    onChange,
    optionsArr,
    disabled
}: {
    value: string;
    onChange: (event: SelectChangeEvent) => void;
    optionsArr: Array<{ label: string; value: string; }>;
    disabled: boolean;
}): JSX.Element {
    const theme = useTheme()

    return (
        <FormControl
            sx={{
                '& .MuiOutlinedInput-root': {
                    '& .MuiSelect-select': {
                        p: '4px 8px',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.text.primary,
                    },
                    '&.Mui-disabled': {
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: theme.palette.grey[900],
                        },
                    },
                },
            }}
        >
            <Select
                labelId="period-dropdown-label"
                id="period-dropdown"
                value={value}
                onChange={onChange}
                sx={{
                    '& .MuiSelect-icon': {
                        color: theme.palette.customColors.aumBlue
                    },
                    '& .MuiSelect-select': {
                        paddingRight: '50px !important',
                    },
                }}
                IconComponent={ExpandMoreIcon}
                disabled={disabled}
            >
                {optionsArr.map((option: { label: string; value: string; }) => (
                    <MenuItem
                        key={`${option.label}-${option.value}`}
                        value={option.value}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}